
<div class="col">
    <br>
    <div class="d-flex justify-content-between align-items-center">
        <h3 class="mb-0">Item Details</h3>
    
        <button type="button" (click)="close()" class="btn-close" aria-label="Close"></button>
    </div>
    <div class="row">
      <table class="table table-bordered  mt-4 tableBusiness">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Item Name</th>
            <th>Item Price</th>
            <th>Quantity</th>
            <th>CSGT</th>
            <th>SGST</th>
            <th>IGST</th>
            <th>Additional Charges</th>
            <th>Total Price</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itemData; let i = index">
            <td>{{i+1}}</td>
            <td>{{item.itemName}}</td>
            <td> {{dialogData?.currency_code | currencySymbol}} {{item.itemPrice}}</td>
            <td>{{item.quantity}}</td>
            <td>{{item.CGST ? item.CGST:0}}<span>&#37;</span></td>
            <td>{{item.SGST ?item.SGST:0}}<span>&#37;</span></td>
            <td>{{item.IGST?item.IGST:0}}<span>&#37;</span></td>
            <td> {{dialogData?.currency_code | currencySymbol}} {{item.Additional_charges}}</td>
            <td> {{dialogData?.currency_code | currencySymbol}} {{item.priceIncludingCharges}}</td>
           
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  